<div class="background-gray default-block-padding event-info-articles">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6">
                <div class="content" [innerHTML]="data.leftColumnContent | bypassSecurity"></div>
            </div>
            <div class="col-lg-6">
                <div class="content" [innerHTML]="data.rightColumnContent | bypassSecurity"></div>
            </div>
        </div>
    </div>
</div>